// Vendor imports
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const PromoBadge = require('client-v2/common/containers/promo-badge/component-smart')

const bem = BemEntity('TopCallToActionExplainerApp')

function TopCallToActionExplainerApp(props) {
  if (!props.isVisible) {
    return null
  }
  return tag('div', {
    className: bem.block()
  },
    tag('div', {
      className: bem.element('heading')
    },
      'Get the app.'
    ),
    tag(PromoBadge, {
      className: bem.element('button')
    })
  )
}

TopCallToActionExplainerApp.propTypes = {
  isVisible: PropTypes.bool
}

module.exports = TopCallToActionExplainerApp
